let apiUrl,pcdUrl,CSMUrl,PFMUrl,queUrl;

console.log(
  process.env.VUE_APP_API_ENV,123123133
);

let reg = /\S+(?=\/\w+.html)/;
let str = window.location.pathname.match(reg)?.[0];
// switch (process.env.VUE_APP_API_ENV) {
//     case "development":
//     apiUrl = "https://kiatest.fontre.com/apiWeb/v1/kia/";
//     pcdUrl = `${window.location.origin}${str || ''}/js/pcd.js`;
//     CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel.js`;
//     PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
//     break;
//     case "uat":
//     apiUrl = "https://api-v2.kia.cn:8001/apiWeb/v1/kia/";
//     pcdUrl = "/assets/~/media/files/genfiles/pcd.js"
//     CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel.js`;
//     PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
//     break;
//     case "production":
//     apiUrl = "https://api-v2.kia.cn:8001/apiWeb/v1/kia/";
//     pcdUrl = "/assets/~/media/files/genfiles/pcd.js"
//     CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel.js`;
//     PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
//     break;
//     default:
//     apiUrl = "https://kiatest.fontre.com/apiWeb/v1/kia/";
//     pcdUrl = `${window.location.origin}${str || ''}/js/pcd.js`
//     CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel.js`;
//     PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
//     break;
// }
switch (process.env.VUE_APP_API_ENV) {
  case "development":
    apiUrl = "https://uat.kia.cn/newkia/apiWeb/v1/kia/";
    queUrl = "/"  // 使用相对路径，让 proxy 生效
    pcdUrl = `${window.location.origin}${str || ''}/js/pcd.js`;
    // CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel2.js`;
    CSMUrl = "https://uat.kia.cn/carSeriesModel.js"
    PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
  break;
  case "uat":
    apiUrl = "https://uat.kia.cn/newkia/apiWeb/v1/kia/";
    queUrl = "https://kiacarservice-uat.kia.cn/ques/"
    pcdUrl = "/assets/~/media/files/genfiles/pcd.js"
    // CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel2.js`;
    CSMUrl = "/carSeriesModel.js"
    PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
  break;
  case "production":
    apiUrl = "https://kiacarservice.kia.cn/newkia/apiWeb/v1/kia/";
    queUrl = "https://kiacarservice.kia.cn/ques/"
    // apiUrl = "https://www.kia.cn/ManawellBizAPI/";
    pcdUrl = "/assets/~/media/files/genfiles/pcd.js"
    // CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel2.js`;
    CSMUrl = "/carSeriesModel.js"
    PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
  break;
  default:
    apiUrl = "/";
    queUrl = "/"
    pcdUrl = `${window.location.origin}${str || ''}/js/pcd.js`;
    // CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel2.js`;
    CSMUrl = "https://uat.kia.cn/carSeriesModel.js"
    PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
  break;
}

export { apiUrl, pcdUrl,CSMUrl,PFMUrl,queUrl};
